import React, { ReactNode }              from 'react';
import { MantineTheme, useMantineTheme } from '@mantine/core';


interface Props {
    dark?: ReactNode;
    light: ReactNode;
}

export const CIcon: React.FC<Props> = ({ dark, light }) => {

    const { colorScheme }: MantineTheme = useMantineTheme();

    return (
        <>
            {colorScheme === 'dark' ? dark : light}
        </>
    );

};
